import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react'; 
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getSuggestedUsers } from '../../../actions/profile';
import theme from '../../../muiTheme';
import SuggestedAccounts from '../../SuggestedAccounts/SuggestedAccounts';

const WhoToFollow = ({profile, isMobile, onCompleted}) => {

    const stage = 3; 
    const dispatch = useDispatch(); 


    useEffect(()=>{

        console.log('profile: ', profile);

        dispatch(getSuggestedUsers(profile ? profile?._id : null));

    }, []); 

    const handleClick = () => {


        if(typeof onCompleted === 'function'){
            onCompleted(profile, stage);
        }
    }


    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                alignItems: 'center',
                top: isMobile ? '0px': '40px',
                justifyContent: 'center',
                padding: '20px 0px',
                paddingBottom: '80px'
            }}
        >

            <Typography variant='h5' sx={{marginBottom: '10px'}}>
                Who to follow?
            </Typography>

            <Typography variant='body1' sx={{marginBottom: '10px', color: theme.palette.gray, textAlign: 'center'}}>
                Here are some suggested accounts to kick things off
            </Typography>

            <SuggestedAccounts limit={7} follow={true}/>

            <Button variant='main' onClick={handleClick} sx={{marginTop: '25px'}}>
                Done!
            </Button>

            
        </Box>
    );
}

export default WhoToFollow; 